export const getUTCDate = (date: number | string): Date =>
    new Date(
        new Date(date).getUTCFullYear(),
        new Date(date).getUTCMonth(),
        new Date(date).getUTCDate(),
    );

export function formatDateTime(date?: string | number | null): Date | null {
    if (!date) {
        return null;
    }

    return new Date(date);
}

export function formatDateToUTC(date?: string | number | null): Date | null {
    if (!date) {
        return null;
    }
    return getUTCDate(date);
}

export function getToday() {
    return new Date(Date.now());
}

function fillDigitsInISO8601(digits: number): string {
    return digits.toString().padStart(2, '0');
}

export function formatDuration(durationInSeconds: number): string {
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds - hours * 3600) / 60);
    const seconds = durationInSeconds - hours * 3600 - minutes * 60;

    return [
        fillDigitsInISO8601(hours),
        fillDigitsInISO8601(minutes),
        fillDigitsInISO8601(seconds),
    ].join(':');
}
